import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * 罗盘上报组件
 * @Author: zzbozheng
 * @Date: 2018-09-21 11:49:06
 * @Last Modified by: zzbozheng
 * @Last Modified time: 2020-04-10 16:39:37
 */
import { setCookie, getCookies, delCookie, getCookie } from './util_03_cookie';
import { isClient, isServer } from './util_00_env';
import { throttle } from './util_23_throttle';
import { getQuery, objectToQueryString, parseQueryString, updateQueryString } from './util_09_url';
import { storage } from './util_05_storage';
import { addEvent, removeEvent } from './util_10_lang';
import { isVisible, detectDomIsVisible } from './util_12_dom';
import { isPC, isMQQ, isWeiBo, isWeixin, isWXLogin, isFudaoApp, getUin, getPlatformCode, getStudentClientVersion, isWeixinMinProgram, createRandomId, checkPhoneLogin } from './util_04_ua';
var globalOptions = {}; // 为了避免 URL 在 Webview 中打开后, from 被覆盖, 修改为 fr 作为参数名

var FROM_URL_KEY = 'fr'; // 兼容老的 from 数据

var FROM_URL_OLD_KEY = 'from'; // Cookie 中的参数名

var FROM_COOKIE_KEY = 'from_source'; // 忽略一些特殊情况, 如微信webview被渡改的老数据

var IGNORE = ['none', 'singlemessage', 'groupmessage', 'timeline'];
var REPORT_URL = 'https://tmapp.qq.com/cgi-bin/activity_platform/tdw/report?pr_ip=userip&';
var REPORT_TABLE = 'dc03920';
var REPORT_DOM_ATTR = 'data-modid';
var REPROT_DOM_SELECTOR = "[".concat(REPORT_DOM_ATTR, "]");
var REPORT_DATA_ATTR = 'data-tdw';
var REPORT_STORAGE_KEY = 'tdw_datas';
var PRESET_STORAGE_KEY = 'tdw_preset';
var SENDING_STORAGE_KEY = "".concat(REPORT_STORAGE_KEY, "_reporting_seqs");
var REPORT_TIMER = 200;
var REPORT_DATA = {};
var randomUid = storage.getGlobal('randomUid');
var hasReportExposePage = false;
/**
 * 把 form 值存储到 Cookie
 * 有效期: 15 min
 * @memberof module:tdw-report
 * @param {string} from
 */

function setFromCookie(from) {
  if (isServer) {
    console.error('Cannot set cookie with server render.');
    return '';
  }

  var exp = new Date();
  exp.setTime(exp.getTime() + 15 * 60 * 1000);
  return setCookie({
    name: FROM_COOKIE_KEY,
    value: from,
    domain: '.fudao.qq.com',
    time: exp.toGMTString()
  });
}
/**
 * 从 Cookie 获取 From 值
 * @memberof module:tdw-report
 * @returns {string | null}
 */


function getFromCookie() {
  if (isServer) {
    console.error('Cannot get document with server render.');
    return null;
  }

  var froms = getCookies(FROM_COOKIE_KEY);

  if (froms.length === 0) {
    return null;
  }

  for (var i = 0; i < froms.length; i++) {
    var from = froms[i];
    var isValid = !['none', ''].includes(from); // TODO: REMOVE
    // 手Q webview 会种一个 key 为 from_source, value 为 qq 的 cookie
    // 还特么永不过期, 等手Q 修复了这个问题后, 去掉该逻辑
    // 坑爹...

    var isQQFromSource = isMQQ() && from === 'qq';

    if (isValid && !isQQFromSource) {
      return from;
    }
  }

  return null;
}
/**
 * 返回环境信息
 * @memberof module:tdw-report
 * @returns {string}
 */


function getFromValueFromEnv() {
  if (isServer) {
    console.error('Cannot get navigator with server render.');
    return '';
  } // 辅导 APP


  if (isFudaoApp()) {
    return 'app';
  } // 手机 QQ


  if (isMQQ()) {
    return 'qq';
  } // 微信


  if (isWeixin) {
    return 'wechat';
  } // 小程序 上报成微信


  if (isWeixinMinProgram) {
    return 'wechat';
  } // 微博


  if (isWeiBo) {
    return 'weibo';
  } // PC


  if (isPC()) {
    return 'web';
  }

  return 'h5';
}
/**
 * 从 URL 获取 From 值
 * @memberof module:tdw-report
 * @param {string?} url
 * @param {string?} key
 * @returns {string}
 */


function getFromValueFromUrlQuery(url, key) {
  if (isServer) {
    console.error('Cannot get window with server render.');
    return null;
  }

  var query = parseQueryString(url || window.location.href);
  return query[key || FROM_URL_KEY];
}
/**
 * 获取 From 值
 * From 存在优先级
 * URL fr 参数 > URL from 参数 > Cookie from_source 参数
 * 没有的话则 UA 判断补齐
 * @memberof module:tdw-report
 * @param {string} url
 * @returns {string}
 */


function getFromValue(url) {
  if (isServer) {
    console.error('Cannot get fromValue with server render.');
    return '';
  }

  var fromQueryAndCookie = getFromValueFromUrlQuery(url) || getFromValueFromUrlQuery(url, FROM_URL_OLD_KEY) || getFromCookie();

  if (IGNORE.includes(fromQueryAndCookie)) {
    return getFromValueFromEnv();
  }

  return fromQueryAndCookie || getFromValueFromEnv();
}
/**
 * 将 fr 加入到 URL 中, 同时保存到 Cookie
 * @memberof module:tdw-report
 * @param {string} url
 * @returns {string}
 */


function addFromToURLAndCookie(url) {
  var from = getFromValue(url);
  setFromCookie(from);
  return updateQueryString(url, 'fr', from);
} // 获取 refer


function getRefer() {
  if (!isClient) {
    return '';
  }

  return document.referrer;
}
/**
 * 用户的登录类型
 * @memberof module:tdw-report
 * @returns {string} 1: QQ登录 2: 微信登录
 *                   3: 手机号登录 4: 未登录
 */


function formatUidType() {
  if (!isClient) {
    return '';
  }

  var uin = getUin();
  var uidType = '';

  if (checkPhoneLogin()) {
    uidType = 3;
  } else if (uin && !isWXLogin) {
    uidType = 1;
  } else if (uin && isWXLogin) {
    uidType = 2;
  } else {
    uidType = 4;
  }

  return uidType;
}
/**
 * 格式化 platform 值
 * @memberof module:tdw-report
 * @returns {string} 返回平台类型 pc, ios, android, other
 */


function formatPlatform() {
  if (!isClient) {
    return '';
  }

  var platform = '';
  var platformCode = getPlatformCode();

  switch (platformCode) {
    case 1:
      platform = 'ios';
      break;

    case 2:
      platform = 'android';
      break;

    default:
      platform = isPC() ? 'pc' : 'other';
      break;
  }

  return platform;
}
/**
 * 格式化 terminal 值
 * @memberof module:tdw-report
 * @returns {string} 返回终端类型 web, client, h5, xcx 其一
 */


function formatTerminal() {
  if (!isClient) {
    return '';
  }

  var terminal = '';

  if (getStudentClientVersion()) {
    terminal = 'client';
  } else if (isWeixinMinProgram) {
    terminal = 'xcx';
  } else if (isPC()) {
    terminal = 'web';
  } else {
    terminal = 'h5';
  }

  return terminal;
} // 获取用户浏览器的唯一ID


function getUniqueUid() {
  if (!isClient) {
    return '';
  }

  if (!randomUid) {
    randomUid = createRandomId() + createRandomId();
    storage.setGlobal('randomUid', randomUid);
  }

  return randomUid;
} // 获取当前页面的 URL


function getUrl() {
  if (!isClient) {
    return '';
  }

  return window.location.href;
} // 获取分享


function getTrans() {
  if (!isClient) {
    return '';
  }

  return getQuery('share') ? 1 : 0;
} // 获取课程id


function getCourseId() {
  if (!isClient) {
    return '';
  }

  return getQuery('course_id');
} // 获取课程包 id


function getCoursePackId() {
  if (!isClient) {
    return '';
  }

  return getQuery('course_pack_id');
} // 获取 termId


function getTermId() {
  if (!isClient) {
    return '';
  }

  return getQuery('term_id');
}

var REPORT_DEFAULT_DATA = {
  event: '',
  event_time: '',
  cookieid: getUniqueUid(),
  uid: getUin(),
  uid_type: formatUidType(),
  platform: formatPlatform(),
  terminal: formatTerminal(),
  env: getFromValueFromEnv(),
  from_source: getFromValue(),
  url: getUrl(),
  refer: getRefer(),
  page: '',
  module: '',
  position: '',
  refer_page: '',
  refer_module: '',
  refer_position: '',
  is_trans: getTrans(),
  // 获取是否是分享后二次打开
  grade: '',
  subject: '',
  course_id: getCourseId(),
  // 课程id
  course_pack_id: getCoursePackId(),
  term_id: getTermId(),
  // termid
  task_id: '',
  // 任务 id
  teacher_uin: '',
  // 老师id
  duration: '',
  // 视频观看时长
  play_type: '',
  search_content: '',
  sub_course_id: '',
  ext: '',
  ext1: '',
  ext2: '',
  ext3: '',
  ext4: '',
  ext5: '',
  ext6: '',
  ext7: ''
}; // 根据 key 获取数据中对应的值function resetReporting

function getValuesByKeys(data, keyList) {
  var valueList = [];
  Object.keys(data).forEach(function (seq) {
    var itemValueList = [];
    keyList.forEach(function (key) {
      itemValueList.push(data[seq][key]);
    });
    valueList.push(itemValueList);
  });
  return valueList;
}

var ReportStorage = /*#__PURE__*/function () {
  function ReportStorage(storageKey) {
    _classCallCheck(this, ReportStorage);

    _defineProperty(this, "storageKey", void 0);

    this.storageKey = storageKey || 'report_storage';
  }
  /**
   * 获取本地缓存中的全量上报数据
   * @memberof module:tdw-report
   * @returns {object} 缓存中的数据
   */


  _createClass(ReportStorage, [{
    key: "getAll",
    value: function getAll() {
      return storage.getGlobal(this.storageKey) || {};
    }
    /**
     * 保存全量上报数据到本地缓存
     * @param {object} 全量上报数据
     */

  }, {
    key: "setAll",
    value: function setAll(data) {
      return storage.setGlobal(this.storageKey, data);
    }
    /**
     * 保存单条上报数据到本地缓存
     * @memberof module:tdw-report
     * @param {string} seq 特定的 seq
     * @param {object} data 要保存的数据
     */

  }, {
    key: "set",
    value: function set(seq, data) {
      var tdwStorage = this.getAll();
      tdwStorage[seq] = data;
      storage.setGlobal(this.storageKey, tdwStorage);
    }
    /**
     * 根据 seqs 批量删除缓存数量
     * @memberof module:tdw-report
     * @param { string|array } [seqs=[]] 要删除的 seqs
     */

  }, {
    key: "del",
    value: function del() {
      var seqs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var tdwStorage = this.getAll();
      seqs = typeof seqs === 'string' ? [seqs] : seqs;
      seqs.forEach(function (seq) {
        delete tdwStorage[seq];
      });
      this.setAll(tdwStorage);
    }
  }]);

  return ReportStorage;
}(); // 正在上报的 seqs


var sendingStorage = {
  formatSeqs: function formatSeqs(seqs) {
    return typeof seqs === 'string' ? [seqs] : seqs;
  },
  getAll: function getAll() {
    return storage.getGlobal(SENDING_STORAGE_KEY) || {};
  },

  /**
   * 保存正在上传的 seqs 到本地缓存
   * @memberof module:tdw-report
   * @param {string} seq 特定的 seq
   * @param {object} data 要保存的数据
   */
  set: function set() {
    var seqs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sendingSeqs = this.getAll();
    seqs = this.formatSeqs(seqs);
    seqs.forEach(function (seq) {
      sendingSeqs[seq] = 1;
    });
    storage.setGlobal(SENDING_STORAGE_KEY, sendingSeqs);
  },

  /**
   * 删除正在上传的 seqs
   * @param { string|array } [seqs=[]]
   */
  del: function del() {
    var seqs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sendingSeqs = this.getAll();
    seqs = this.formatSeqs(seqs);
    seqs.forEach(function (seq) {
      delete sendingSeqs[seq];
    });
    storage.setGlobal(SENDING_STORAGE_KEY, sendingSeqs);
  }
};
var reportStorage = new ReportStorage(REPORT_STORAGE_KEY);
var presetStorage = new ReportStorage(PRESET_STORAGE_KEY); // 上报完毕

function onReportFinish(reportSeqs) {
  sendingStorage.del(reportSeqs);
  reportStorage.del(reportSeqs);
  this.onload = null;
  this.onerror = null;
} // 发送上报请求


function send(reportParams) {
  var reportSeqs = Object.keys(reportParams);

  if (!isClient || reportSeqs.length === 0) {
    return;
  }

  var reportKeys = Object.keys(REPORT_DEFAULT_DATA);
  var reportValues = getValuesByKeys(reportParams, reportKeys);
  var img = new Image();
  var sendParams = {
    table: REPORT_TABLE,
    fields: JSON.stringify(reportKeys),
    datas: JSON.stringify(reportValues)
  };
  console.log('tdw report data:');
  console.table(reportParams, reportKeys);

  img.onload = function () {
    onReportFinish.call(img, reportSeqs);
  };

  img.onerror = function () {
    onReportFinish.call(img, reportSeqs);
  };

  img.src = "".concat(REPORT_URL).concat(objectToQueryString(sendParams));
}
/**
 * 合并上报
 * @param {object} reportParams 合并上报数据
 */


function mergeReport() {
  setTimeout(function () {
    var sendingSeqs = sendingStorage.getAll();
    var reportParams = reportStorage.getAll(); // 剔除正在上报中的 seqs

    Object.keys(sendingSeqs).forEach(function (seq) {
      delete reportParams[seq];
    });
    var reportKeys = Object.keys(reportParams);

    if (reportKeys.length === 0) {
      return;
    } // 标记正在上报中的 seqs


    sendingStorage.set(reportKeys); // 5条记录合并为一次请求，防止 URL 超长

    var _loop = function _loop() {
      var reportKeyList = reportKeys.splice(0, 5);
      var reportObj = {};
      reportKeyList.forEach(function (reportKey) {
        reportObj[reportKey] = reportParams[reportKey];
      });
      send(reportObj);
    };

    while (reportKeys.length > 0) {
      _loop();
    }
  }, REPORT_TIMER);
}
/**
 * 立即上报
 * @memberof module:tdw-report
 * @param {object} reportParams 立即上报数据
 */


function immedReport(seq, reportParams) {
  var sendingSeqs = sendingStorage.getAll();

  if (sendingSeqs[seq]) {
    return;
  } // 正在上报的 seq 写到本地缓存中，避免同时上报


  sendingStorage.set(seq);
  send(_defineProperty({}, seq, reportParams));
} // 保存预设数据，用于跳转到下一个页面上报的 refer_* 字段


function preset() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var module = params.module,
      position = params.position;
  url = url.replace(/^https?:/, '');
  var reportParams = {
    ctime: new Date().getTime(),
    refer: window.location.href,
    refer_page: REPORT_DATA.page,
    refer_module: module,
    refer_position: position
  };
  presetStorage.set(url, reportParams);
} // 获取预设数据


function getPreset() {
  var currPageLink = window.location.href.replace(/^https?:/, '');
  var presetDatas = presetStorage.getAll();
  var currPresetData = presetDatas[currPageLink];

  if (currPresetData) {
    presetStorage.del(currPageLink);
    return currPresetData;
  }

  if (!isServer) {
    /** 如果Cookie 里有数据，则取出来，然后删除 */
    var cookiePresetData = getCookie('__tdw_refer') || '';

    if (cookiePresetData) {
      delCookie('__tdw_refer');
      var cookiePresetDataArray = cookiePresetData.split('.');
      var cookiePresetDataMap = {};

      if (cookiePresetDataArray.length > 1) {
        cookiePresetDataMap.refer_page = cookiePresetDataArray[0];
        cookiePresetDataMap.refer_module = cookiePresetDataArray[1];
        cookiePresetDataMap.refer_position = cookiePresetDataArray[2];
      }

      return cookiePresetDataMap;
    }
  }

  return {};
} // 过滤掉 preset 数据，并设置 preset


function filterPreset(params) {
  var url = params.url,
      pureParams = _objectWithoutProperties(params, ["url"]);

  var module = pureParams.module,
      position = pureParams.position;

  if (url) {
    preset(url, {
      module: module,
      position: position
    });
  }

  return pureParams;
} // 对外暴露的上报接口


function report() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var immed = arguments.length > 1 ? arguments[1] : undefined;

  if (params instanceof Object && !(params instanceof Array)) {
    var pureParams = filterPreset(params);
    var eventTime = new Date().valueOf(); // 当前时间戳

    var seq = createRandomId(); // 创建 seq 唯一标记

    var reportParams = _objectSpread(_objectSpread(_objectSpread({
      env: getFromValueFromEnv(),
      from_source: getFromValue()
    }, REPORT_DATA), pureParams), {}, {
      event_time: eventTime,
      _seq: seq
    }); // 先保存到缓存


    reportStorage.set(seq, reportParams);

    if (immed) {
      // 立即上报
      immedReport(seq, reportParams);
    } else {
      // 合并上报
      mergeReport();
    }
  } else {
    var ArgsError = function ArgsError() {
      this.name = 'tdwReport error';
      this.message = 'tdwReport\'s arguments must be an JSON Object!';
    };

    ArgsError.prototype = new Error();
    ArgsError.prototype.constructor = ArgsError;
    throw new ArgsError();
  }
} // 删除超时的预设数据


function delExpirePreset() {
  var presetDatas = presetStorage.getAll();
  Object.keys(presetDatas).forEach(function (seq) {
    // 把超过 5 秒未上报的缓存数据清除
    if ((new Date().getTime() - presetDatas[seq].ctime) / 1000 > 5) {
      presetStorage.del(seq);
    }
  });
} // 页面曝光上报


function reportExposePage() {
  if (globalOptions.isAutoExposePage && !hasReportExposePage) {
    hasReportExposePage = true;
    report({
      event: 'pageview'
    });
  }
} // 上报曝光的 dom


function reportExposeDom(doms) {
  _toConsumableArray(doms).forEach(function (dom) {
    if (dom && !dom.getAttribute('has-expose') && isVisible(dom)) {
      dom.setAttribute('has-expose', 1); // 标记已上报

      report(_objectSpread({
        event: 'expose',
        module: dom.getAttribute(REPORT_DOM_ATTR)
      }, JSON.parse(dom.getAttribute(REPORT_DATA_ATTR) || '{}')));
    }
  });
} // 监听页面 onload


function onLoad() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  if (document.readyState === 'complete') {
    callback();
  } else {
    addEvent(window, 'load', callback, false);
  }
}

function scrollExposeEvent() {
  var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
  reportExposeDom(watchDoms);
}

var throttleScrollExposePage = throttle(scrollExposeEvent, 100); // 模块曝光事件绑定

function bindExposeDom(parentDom) {
  onLoad(function () {
    var targetDom = parentDom || window;
    var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
    reportExposeDom(watchDoms); // 默认触发一次

    addEvent(targetDom, 'scroll', throttleScrollExposePage, false);
  });
} // 事件绑定


function bindEvents() {
  var _globalOptions = globalOptions,
      isUseIntervalExpose = _globalOptions.isUseIntervalExpose;
  var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
  var doms = [].slice.call(watchDoms);
  detectDomIsVisible({
    doms: doms,
    callback: function callback(dom) {
      if (dom && !dom.getAttribute('has-expose')) {
        dom.setAttribute('has-expose', '1'); // 标记已上报

        report(_objectSpread({
          event: 'expose',
          module: dom.getAttribute(REPORT_DOM_ATTR)
        }, JSON.parse(dom.getAttribute(REPORT_DATA_ATTR) || '{}')));
      }
    },
    options: {
      useInterval: isUseIntervalExpose
    }
  }); // if (isUseIntervalExpose) {
  //   intervalReportExpose();
  // } else {
  //   if (window.IntersectionObserver) {
  //     bindExposeDomInterObserver(reportExposeDom);
  //   } else {
  //     bindExposeDom();
  //   }
  // }
} // 解绑事件


function unbindEvents(parentDom) {
  var targetDom = parentDom || window;
  removeEvent(targetDom, 'scroll', throttleScrollExposePage);
} // 间隔上报曝光模块


function intervalReportExpose() {
  setInterval(function () {
    var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
    reportExposeDom(watchDoms); // 默认触发一次
  }, globalOptions.intervalTime);
} // 给链接添加 share=1 标记


function addShareFlag() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (url.indexOf('?') > -1) {
    url = url.replace('?', '?share=1&');
  } else if (url.indexOf('#') > -1) {
    url = url.replace('#', '?share=1#');
  } else {
    url += '?share=1';
  }

  return url;
} // 每次初始化时检查并重置正在上报中的 seqs


function resetReporting() {
  var sendingSeqs = Object.keys(sendingStorage.getAll());
  var reportParams = reportStorage.getAll();

  if (sendingSeqs.length > 0) {
    sendingSeqs.forEach(function (seq) {
      var reportParam = reportParams[seq]; // 从缓存中查找对应的seq

      var eventTime = reportParam ? reportParam.event_time : new Date(); // 缓存中超过3秒的重置

      if ((new Date().getTime() - eventTime) / 1000 > 3) {
        sendingStorage.del(seq);
      }
    });
  }
}

function setFromValueCookieFromURL() {
  var fr = getFromValueFromUrlQuery();

  if (fr) {
    setFromCookie(fr);
  }
} // 初始化


function init() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isUseIntervalExpose: true,
    intervalTime: 200,
    isAutoExposePage: true
  };
  globalOptions = options;
  delExpirePreset();
  var presetData = getPreset();
  REPORT_DATA = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, REPORT_DATA), REPORT_DEFAULT_DATA), presetData), data), {}, {
    env: getFromValueFromEnv(),
    from_source: getFromValue()
  });
  reportExposePage();
  bindEvents();
  resetReporting();
  setFromValueCookieFromURL();
  addEvent(window, 'hashchange', setFromValueCookieFromURL, false);
}

function config() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  REPORT_DATA = _objectSpread(_objectSpread(_objectSpread({}, REPORT_DATA), data), {}, {
    env: getFromValueFromEnv(),
    from_source: getFromValue()
  });
}

var tdwReport = {
  init: init,
  config: config,
  report: report,
  preset: preset,
  unbindEvents: unbindEvents,
  addShareFlag: addShareFlag,
  bindExposeDom: bindExposeDom,
  addFromToURLAndCookie: addFromToURLAndCookie,
  getFromValueFromEnv: getFromValueFromEnv,
  getFromValue: getFromValue,
  getFromSource: getFromValue,
  getFromValueFromUrlQuery: getFromValueFromUrlQuery
};

if (isClient) {
  window.GE_REPORT = window.GE_REPORT || tdwReport;
  window.tdwReport = tdwReport;
}
/* eslint-disable import/prefer-default-export */


export { tdwReport };